export const HOME = {
  emergentLink: "emergent-link",
};

export const SIDEBAR = {
  nav: "sidebar-nav",
  dashboardLink: "sidebar-dashboard-link",
  clustersLink: "sidebar-clusters-link",
  topologyLink: "sidebar-topology-link",
  explorerLink: "sidebar-explorer-link",
  monitoringLink: "sidebar-monitoring-link",
  analyticsLink: "sidebar-analytics-link",
  incidentsLink: "sidebar-incidents-link",
  costLink: "sidebar-cost-link",
  assistantLink: "sidebar-assistant-link",
  settingsLink: "sidebar-settings-link",
};

export const TOPBAR = {
  searchBtn: "topbar-search-btn",
  themeToggle: "topbar-theme-toggle",
  clusterSelector: "topbar-cluster-selector",
  notificationBtn: "topbar-notification-btn",
};

export const DASHBOARD = {
  page: "dashboard-page",
  healthScore: "dashboard-health-score",
  cpuUsage: "dashboard-cpu-usage",
  memoryUsage: "dashboard-memory-usage",
  totalClusters: "dashboard-total-clusters",
  totalNodes: "dashboard-total-nodes",
  totalPods: "dashboard-total-pods",
  totalDeployments: "dashboard-total-deployments",
  alertsWidget: "dashboard-alerts-widget",
  eventsWidget: "dashboard-events-widget",
  metricsChart: "dashboard-metrics-chart",
};

export const CLUSTERS = {
  page: "clusters-page",
  clusterCard: "cluster-card",
  healthBadge: "cluster-health-badge",
  addClusterBtn: "add-cluster-btn",
};

export const TOPOLOGY = {
  page: "topology-page",
  canvas: "topology-canvas",
  filterBar: "topology-filter-bar",
  zoomIn: "topology-zoom-in",
  zoomOut: "topology-zoom-out",
  resetView: "topology-reset-view",
};

export const AI_ASSISTANT = {
  page: "ai-assistant-page",
  chatInput: "ai-chat-input",
  sendBtn: "ai-send-btn",
  chatContainer: "ai-chat-container",
  newChatBtn: "ai-new-chat-btn",
  messageItem: "ai-message-item",
};

export const MONITORING = {
  page: "monitoring-page",
  cpuChart: "monitoring-cpu-chart",
  memoryChart: "monitoring-memory-chart",
  networkChart: "monitoring-network-chart",
};

export const INCIDENTS = {
  page: "incidents-page",
  incidentCard: "incident-card",
  statusBadge: "incident-status-badge",
};

export const COST = {
  page: "cost-page",
  totalCost: "cost-total",
  savingsWidget: "cost-savings-widget",
  namespaceBreakdown: "cost-namespace-breakdown",
};
